module.exports = "<div ckeditor-inline\n     class=\"editor-inline__container\"\n     options=\"$ctrl.options\"\n     ng-model=\"$ctrl.model\">\n</div>\n\n<style>\n    .editor-inline__container:empty::after {\n        content: '{{ \"Insert text here...\"|translate }}';\n    }\n</style>";


//////////////////
// WEBPACK FOOTER
// ./src/cmsCore/RichTextEditor/EditorInline/editor-inline.html
// module id = 1137
// module chunks = 0